import { Action, Module, VuexModule } from "vuex-module-decorators";
import { ZaMap } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";

@Module
export default class ZaMapModule extends VuexModule {
    @Action
    [ZaMap.getList]() {
        return new Promise<void>((resolve, reject) => {
            ApiService.get(`/map/list`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [ZaMap.findPage](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/map`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [ZaMap.save](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/map/save`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [ZaMap.delete](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/map/delete`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

}